// Navbar behaviour — burger menu + user dropdown
// Compatible with Turbolinks: listeners are attached on every turbolinks:load
// and the document-level close listener is cleaned up before each cache snapshot
// so it never accumulates between navigations.

function setupNavbar() {
  var navbar = document.querySelector('.navbar_box');
  if (!navbar) return;

  var burger   = navbar.querySelector('[data-navbar-burger]');
  var dropdown = navbar.querySelector('[data-navbar-dropdown]');
  var toggle   = dropdown && dropdown.querySelector('[data-dropdown-toggle]');

  // ── Burger (mobile menu open/close) ──────────────────────────────────────
  if (burger) {
    burger.addEventListener('click', function (e) {
      navbar.classList.toggle('nav-open');
      e.stopPropagation();
    });
  }

  // ── Desktop user dropdown ─────────────────────────────────────────────────
  if (toggle && dropdown) {
    toggle.addEventListener('click', function (e) {
      dropdown.classList.toggle('is-open');
      e.stopPropagation();
    });
  }

  // ── Close everything when clicking outside ────────────────────────────────
  function closeMenus(e) {
    if (!navbar.contains(e.target)) {
      navbar.classList.remove('nav-open');
      if (dropdown) dropdown.classList.remove('is-open');
    }
  }

  document.addEventListener('click', closeMenus);

  // Clean up before Turbolinks snapshots the page so the listener does not
  // accumulate across navigations.
  document.addEventListener('turbolinks:before-cache', function cleanup() {
    document.removeEventListener('click', closeMenus);
    document.removeEventListener('turbolinks:before-cache', cleanup);
    navbar.classList.remove('nav-open');
    if (dropdown) dropdown.classList.remove('is-open');
  });
}

document.addEventListener('turbolinks:load', setupNavbar);
